import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonGroup, Stack, Tab, Tabs,
} from '@mui/material';
import Buttons from '../../../../components/buttons';

function TPCommandPanel({
  children, actions, permissions, pages, currentPage, activeRow,
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <ButtonGroup>
        <Buttons.AddRowButton
          onClick={actions.onAddRow}
          disabled={!(permissions.canAdd && actions.onAddRow)}
        />
        <Buttons.DeleteRowButton
          onClick={(e) => actions.onDeleteRow(e, activeRow)}
          disabled={!(permissions.canDelete && actions.onDeleteRow)}
        />
      </ButtonGroup>
      {/* TODO: ФИльтрация */}
      {/* <ButtonGroup> */}
      {/*  <Buttons.FiltersButton */}
      {/*    onClick={() => actions.onToggleFilterOpened()} */}
      {/*    disabled={!permissions.canFilter} */}
      {/*    color={filterApplied ? 'warning' : 'secondary'} */}
      {/*  /> */}
      {/* </ButtonGroup> */}
      {children}
      {pages && !!pages.length && (
        <Tabs
          value={currentPage}
          variant="scrollable"
          scrollButtons="auto"
          onChange={actions.onChangePage}
        >
          {pages.map((page) => (
            <Tab key={page.id} label={page.label} value={page.id} />
          ))}
        </Tabs>
      )}
    </Stack>
  );
}

TPCommandPanel.propTypes = {
  actions: PropTypes.shape({
    onAddRow: PropTypes.func.isRequired,
    onDeleteRow: PropTypes.func.isRequired,
    onChangePage: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({
    canAdd: PropTypes.bool,
    canDelete: PropTypes.bool,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  pages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string,
  })),
  currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  activeRow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TPCommandPanel.defaultProps = {
  children: null,
  pages: null,
  currentPage: false,
  activeRow: null,
};

export default memo(TPCommandPanel);
